export const NAME_PATTERN = '[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ _-]{1,50}';
